import { render, staticRenderFns } from "./HelpSendOrders.vue?vue&type=template&id=251c8b34&"
import script from "./HelpSendOrders.vue?vue&type=script&lang=js&"
export * from "./HelpSendOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports